(() => {
  if (customElements.get('banner-swiper')) {
    return;
  }

  class BannerSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.contentSlider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initMainSlider();
    }

    initMainSlider() {
      this.options = {
        slidesPerView: 1,
        loop: true,
        watchSlidesProgress: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
      };

      this.options.speed = Number(this.dataset.transitionSpeed) || 500;

      if (this.dataset.transitionEffect === 'fade') {
        this.options.effect = 'fade';
        this.options.fadeEffect = { crossFade: true };
      }

      if (this.dataset.autoplay === 'true') {
        this.options.autoplay = {
          delay: Number(this.dataset.autoplayDelay) || 3000,
          disableOnInteraction: false,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('banner-swiper', BannerSwiper);
})();